import { BCMSRecord, Branding, useBCMSContext, useParams } from "@bcm-dev/bcms-vite";
import WidgetContainer, { WidgetNavItem } from 'components/shared/containers/WidgetContainer';
import Classes, { Card } from "model";
import './styles.css';

export default function ManageCardNavWidget(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const branding = globalController.state.branding;
  const defaultCard = globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
  let cardID = useParams().cardID ?? defaultCard;
  const creditCardOptionOn = globalController.state.branding.options.include_credit_chw23 !== "false";

  if(!creditCardOptionOn && cardID === "1") {
    cardID = "0";
  }
  const card = Card.initByID(cardID);

  const shouldDisable = card.active === false || card.recentlyAdded === true;

  const controlsRoute = !shouldDisable ? `/home/controlsalerts/controls/${ cardID }` : "";
  const addToWalletRoute = !shouldDisable ? `/home/addtowallet/${ cardID }` : "";
  const manageTravelRoute = !shouldDisable ? `/home/managetravelplans/${ cardID }` : "";
  const balanceTransferRoute = !shouldDisable ? `/home/securitytoken/receivetoken/${ cardID }/balancetransfers` : "";
  const managePinRoute = !shouldDisable ? `/home/managepin/${ cardID }` : "";
  const setPinRoute = !shouldDisable ? `/home/securitytoken/receivetoken/${ cardID }/setpin` : "";
  const cardFreeCashRoute = !shouldDisable ? "/cardfreecash/selectcashamount" : "";
  const replaceCardRoute = !shouldDisable ? `/home/replacemycard/replacecardaddress/${ cardID }` : "";
  let reportRoute = !shouldDisable ? `/home/reportloststolen/report/${ cardID }` : "";

  const lostStolenOptions = {
    directToCall: "direct to call",
    directToCallButAsk: "direct to call but ask if lost or stolen",
    directToCallWithDigitalIssuance: "direct to call with digital issuance"
  };

  const debitBranding = branding.options.loststolen_debit_chw23;
  const creditBranding = branding.options.loststolen_credit_chw23;
  const optionToUse = card.type === "debit" ? debitBranding : creditBranding;

  if(!shouldDisable && optionToUse === lostStolenOptions.directToCall) {
    reportRoute = `/home/reportloststolen/turnoffcard/${ cardID }`;
  }

  return(
    <WidgetContainer headerText="Manage Card" className="manage-card-nav-widget" dataPoint="Manage_Card_header" key={card.id}>
      <WidgetNavItem text="Controls & Alerts" icon="LockIcon" dataPoint="Manage_Card_Controls" route={ controlsRoute }/>

      <Branding id="digital_wallet_chw23"  exp={val => val === "true"}>
        <WidgetNavItem text="Add to Wallet" icon="WalletSignalIcon" route={ addToWalletRoute }/>
      </Branding>

      <Branding id="travel_plan_chw23"  exp={val => val !== "false"}>
        <WidgetNavItem text="Manage Travel Plans" icon="AirplaneIcon" dataPoint="Manage_Card_Travel_Plans" route={ manageTravelRoute }/>
      </Branding>

      <Branding id="balance_transfer_chw23"  exp={val => val === "true"}>
      { card.type === "credit" &&
      <WidgetNavItem text="Balance Transfer" icon="TwoHalfArrowsIcon" dataPoint="Balance_Transfer" route={ balanceTransferRoute } />
      }
      </Branding>

      <Branding id="lost_stolen_chw23" value="true">
        <Branding id="loststolen_debit_chw23" exp={ val => val !== "no" && card.type === "debit" }>
          <WidgetNavItem text="Report Lost or Stolen" icon="DocumentsAlertIcon" dataPoint="Manage_Card_Lost" route={ reportRoute }/>
        </Branding>

        <Branding id="loststolen_credit_chw23" exp={ val => val !== "no" && card.type === "credit" }>
          <WidgetNavItem text="Report Lost or Stolen" icon="DocumentsAlertIcon" dataPoint="Manage_Card_Lost" route={ reportRoute }/>
        </Branding>
      </Branding>

      {
        card.type === "debit" &&
        <Branding id="replace_card_chw23"  exp={val => val !== "false"}>
          <Branding id="replace_card_debit_chw23" value="true" default="true">
            <WidgetNavItem text="Replace Card" icon="ReplaceCardIcon" dataPoint="Manage_Card_Replace" route={ replaceCardRoute } />
          </Branding>
        </Branding>
      }

      {
        card.type === "credit" &&
        <Branding id="replace_card_chw23"  exp={val => val !== "false"}>
          <Branding id="replace_card_credit_chw23" value="true" default="true">
            <WidgetNavItem text="Replace Card" icon="ReplaceCardIcon" dataPoint="Manage_Card_Replace" route={ replaceCardRoute } />
          </Branding>
        </Branding>
      }

      <Branding id="manage_pin_chw23"  exp={val => val !== "false"}>
        <Branding id="pin_version_chw23" exp={ val => val !== "Set PIN" }>
          <WidgetNavItem text="Manage PIN" icon="PinIcon" dataPoint="Manage_Card_Pin" route={ managePinRoute }/>
        </Branding>
        <Branding id="pin_version_chw23" value="Set PIN">
          <WidgetNavItem text="Set PIN" icon="PinIcon" dataPoint="Manage_Card_Pin" route={ setPinRoute } />
        </Branding>       
      </Branding>
      <Branding id="cardfree_cash_chw23" value="true" exp={val => val === "true"}>
        { card.type === "debit" &&
        <WidgetNavItem text="CardFree Cash" icon="CardFreeCashIcon" dataPoint="Manage_Card_Free_Cash" route={ cardFreeCashRoute } />
        }
        </Branding>
    </WidgetContainer>
  );
}